<!-- Standalone mode -->
<ng-container *ngIf="!embedded; else embeddedTpl">
    <div class="container-fluid px-3 px-md-4 mt-4 mb-5" style="max-width:720px" *ngIf="event; else loading">
        <div class="d-flex align-items-center flex-wrap mb-1">
            <h5 class="mb-0 mr-2">{{ event!.title }}</h5>
            <span class="rana-badge rana-badge-neutral">{{ event!.status }}</span>
        </div>
        <p class="text-muted small mb-3">
            <i class="uil uil-calendar-alt mr-1"></i>{{ event!.eventStartDate }}
        </p>
        <ng-container *ngTemplateOutlet="attendeesTable"></ng-container>
    </div>
    <ng-template #loading>
        <div class="container mt-5 text-center text-muted"><p>Loading event...</p></div>
    </ng-template>
</ng-container>

<!-- Embedded mode -->
<ng-template #embeddedTpl>
    <div class="p-3" *ngIf="event">
        <ng-container *ngTemplateOutlet="attendeesTable"></ng-container>
    </div>
</ng-template>

<ng-template #attendeesTable>

    <!-- ===== CONFERENCE layout ===== -->
    <ng-container *ngIf="isConference; else localTable">

        <!-- Desktop table (md+) -->
        <div class="table-responsive mb-4 d-none d-md-block rana-table-flat">
            <table #bookingsDt datatable [dtOptions]="bookingsDtOptions" [dtTrigger]="bookingsDtTrigger" class="table rana-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Options Selected</th>
                        <th>Total</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody></tbody>
                <tfoot *ngIf="bookings.length > 0">
                    <tr class="font-weight-bold bg-light">
                        <td>Total</td>
                        <td>{{ bookings.length }} booking(s)</td>
                        <td></td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <!-- Mobile cards (below md) -->
        <div class="d-md-none mb-4">
            <div *ngFor="let b of bookings" class="card mb-2">
                <div class="card-body p-2">
                    <div class="font-weight-bold mb-1">{{ userNames[b.userId] || b.userId }}</div>
                    <div class="text-muted small mb-1">{{ formatOptions(b.selectedOptions || []) }}</div>
                    <div class="d-flex justify-content-between text-muted small">
                        <span>Total: {{ (b.totalAmount || 0) | currency:'USD' }}</span>
                        <span class="rana-badge rana-badge-neutral">{{ b.status }}</span>
                    </div>
                </div>
            </div>
            <div *ngIf="!bookings.length" class="text-center text-muted py-3">No bookings yet.</div>
        </div>

    </ng-container>

    <!-- ===== LOCAL layout ===== -->
    <ng-template #localTable>

        <!-- Empty state -->
        <div *ngIf="!event?.eventRegistrations || event?.eventRegistrations?.length === 0"
             class="text-center text-muted py-4">No registrations yet.</div>

        <ng-container *ngIf="event?.eventRegistrations && event?.eventRegistrations?.length! > 0">

            <!-- Desktop table (md+) -->
            <div class="table-responsive mb-4 d-none d-md-block rana-table-flat">
                <table #regsDt datatable [dtOptions]="regsDtOptions" [dtTrigger]="regsDtTrigger" class="table rana-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Adults</th>
                            <th>Children</th>
                            <th>Seniors</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                    <tfoot>
                        <tr class="font-weight-bold bg-light">
                            <td>Total</td>
                            <td>{{ totalAdults }}</td>
                            <td>{{ totalChildren }}</td>
                            <td>{{ totalSeniors }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <!-- Mobile cards (below md) -->
            <div class="d-md-none mb-4">
                <div *ngFor="let reg of event?.eventRegistrations" class="card mb-2">
                    <div class="card-body p-2">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <span class="font-weight-bold">{{ userNames[reg.userId] || reg.userId }}</span>
                        </div>
                        <div class="d-flex justify-content-between text-muted small">
                            <span>Adults: {{ reg.adults }}</span>
                            <span>Children: {{ reg.children }}</span>
                            <span>Seniors: {{ reg.seniors }}</span>
                        </div>
                    </div>
                </div>
                <div class="card mb-2 border-primary">
                    <div class="card-body p-2">
                        <div class="font-weight-bold mb-1">Total</div>
                        <div class="d-flex justify-content-between small">
                            <span>Adults: {{ totalAdults }}</span>
                            <span>Children: {{ totalChildren }}</span>
                            <span>Seniors: {{ totalSeniors }}</span>
                        </div>
                    </div>
                </div>
            </div>

        </ng-container>

    </ng-template>

</ng-template>